module.exports = __webpack_public_path__ + "static/media/12.d4b38451.jpg";